import registry from "./workspace-admin-permissions.json";
import {normalizePermissionList} from "./workspace-permissions";

export const WORKSPACE_ADMIN_PERMISSION_GROUPS = registry.groups;
export const WORKSPACE_ADMIN_PERMISSIONS = registry.groups
    .flatMap((group) => group.permissions);
export const WORKSPACE_ADMIN_PERMISSION_KEYS = WORKSPACE_ADMIN_PERMISSIONS
    .map((permission) => permission.key);

const permissionMap = new Map(
    WORKSPACE_ADMIN_PERMISSIONS.map((permission) => [permission.key, permission]),
);
const CUSTOM_PERMISSION_PATTERN = /^[a-z][a-z0-9._:-]{1,127}$/;
const RETIRED_PLATFORM_PERMISSIONS = new Set([
    "workspace.billing.manage",
    "workspace.messaging.use",
    "canManageBilling",
]);

export function normalizeWorkspaceAdminPermissions(value) {
    const normalized = normalizePermissionList(value)
        .filter((permission) => CUSTOM_PERMISSION_PATTERN.test(permission))
        .filter((permission) => !RETIRED_PLATFORM_PERMISSIONS.has(permission));
    const selected = new Set(
        normalized,
    );

    let dependencyAdded = true;
    while (dependencyAdded) {
        dependencyAdded = false;
        for (const permission of [...selected]) {
            for (const dependency of permissionMap.get(permission)?.dependencies || []) {
                if (!selected.has(dependency)) {
                    selected.add(dependency);
                    dependencyAdded = true;
                }
            }
        }
    }

    return [
        ...WORKSPACE_ADMIN_PERMISSION_KEYS.filter((permission) => selected.has(permission)),
        ...normalized.filter((permission) => !WORKSPACE_ADMIN_PERMISSION_KEYS.includes(permission)),
    ];
}

export function toggleWorkspaceAdminPermission(value, permission, enabled) {
    const selected = new Set(normalizeWorkspaceAdminPermissions(value));
    if (enabled) {
        selected.add(permission);
    } else {
        selected.delete(permission);
        for (const candidate of WORKSPACE_ADMIN_PERMISSIONS) {
            if (candidate.dependencies?.includes(permission)) selected.delete(candidate.key);
        }
    }
    return normalizeWorkspaceAdminPermissions([...selected]);
}

export function setWorkspaceAdminPermissionGroup(value, groupId, enabled) {
    const group = WORKSPACE_ADMIN_PERMISSION_GROUPS.find((item) => item.id === groupId);
    if (!group) return normalizeWorkspaceAdminPermissions(value);

    let next = normalizeWorkspaceAdminPermissions(value);
    for (const permission of group.permissions) {
        next = toggleWorkspaceAdminPermission(next, permission.key, enabled);
    }
    return next;
}
